import { useLocalStorage } from '@whistler-ui/k2/hooks';

export const useStoredPreviousUrl = () => {
  const [previousUrlValue, setPreviousUrlValue, clearPreviousUrl] = useLocalStorage<string>('previous-url');

  return {
    previousUrlValue,
    setPreviousUrlValue,
    clearPreviousUrl, 
  };
};
